"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseUserShortName = exports.baseUserFullName = exports.baseUserFormalName = exports.baseUserCasualName = exports.baseUserPhoneSafe = exports.baseUserFromUser = exports.baseUserDeserialize = exports.baseUserDescription = void 0;
const ModelDescription_1 = require("../type-descriptions/ModelDescription");
const String_1 = require("../type-descriptions/String");
const unwrap_1 = __importDefault(require("../util/unwrap"));
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializePhoneNumber_1 = __importDefault(require("./deserializePhoneNumber"));
const deserializeString_1 = require("./deserializeString");
exports.baseUserDescription = (0, ModelDescription_1.modelDescription)({
    properties: {
        cellphone: Object.assign(Object.assign({}, (0, String_1.stringDescription)()), { isOptional: true }),
        firstName: (0, String_1.stringDescription)(),
        lastName: (0, String_1.stringDescription)(),
        nickName: Object.assign(Object.assign({}, (0, String_1.stringDescription)()), { isOptional: true }),
        phone: Object.assign(Object.assign({}, (0, String_1.stringDescription)()), { isOptional: true }),
        proxyPhone: Object.assign(Object.assign({}, (0, String_1.stringDescription)()), { isOptional: true }),
    },
});
function baseUserDeserialize(value) {
    var _a, _b, _c;
    const object = (0, deserializeObject_1.default)(value, 'base user');
    return {
        cellphone: (0, unwrap_1.default)(object.cellphone, deserializePhoneNumber_1.default),
        firstName: (_a = (0, unwrap_1.default)(object.firstName, deserializeString_1.deserializeString)) !== null && _a !== void 0 ? _a : '',
        lastName: (_b = (0, unwrap_1.default)(object.lastName, deserializeString_1.deserializeString)) !== null && _b !== void 0 ? _b : '',
        nickName: (0, unwrap_1.default)(object.nickName, deserializeString_1.deserializeString),
        phone: (_c = (0, unwrap_1.default)(object.phone, deserializePhoneNumber_1.default)) !== null && _c !== void 0 ? _c : (0, unwrap_1.default)(object.cellphone, deserializePhoneNumber_1.default),
        proxyPhone: (0, unwrap_1.default)(object.proxyPhone, deserializeString_1.deserializeString),
    };
}
exports.baseUserDeserialize = baseUserDeserialize;
function baseUserFromUser(user) {
    var _a;
    return {
        cellphone: (_a = user.cellphone) !== null && _a !== void 0 ? _a : user.phone,
        firstName: user.firstName,
        lastName: user.lastName,
        nickName: user.nickName,
        phone: user.phone,
    };
}
exports.baseUserFromUser = baseUserFromUser;
function baseUserPhoneSafe(user) {
    var _a;
    return (_a = user.phone) !== null && _a !== void 0 ? _a : user.cellphone;
}
exports.baseUserPhoneSafe = baseUserPhoneSafe;
/**
 * (nickname or first name) + last name
 */
function baseUserCasualName(user) {
    var _a;
    return [(_a = user.nickName) !== null && _a !== void 0 ? _a : user.firstName, user.lastName].filter(Boolean).join(' ');
}
exports.baseUserCasualName = baseUserCasualName;
/**
 * first name + last name
 */
function baseUserFormalName(user) {
    return [user.firstName, user.lastName].filter(Boolean).join(' ');
}
exports.baseUserFormalName = baseUserFormalName;
/**
 * first name + nickname + last name
 */
function baseUserFullName(user) {
    return [user.firstName, (0, unwrap_1.default)(user.nickName, n => `"${n}"`), user.lastName].filter(Boolean).join(' ');
}
exports.baseUserFullName = baseUserFullName;
/**
 * nickname or first name
 */
function baseUserShortName(user) {
    var _a;
    return (_a = user.nickName) !== null && _a !== void 0 ? _a : user.firstName;
}
exports.baseUserShortName = baseUserShortName;
